import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalytics } from '@/lib/analytics';

/**
 * PageViewTracker automatically tracks page views when the route changes
 */
export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const analytics = getAnalytics();
    if (!analytics) return;

    // Get page title from route
    const getPageTitle = (pathname: string): string => {
      const routes: Record<string, string> = {
        '/': 'Dashboard',
        '/intake': 'Intake Requests',
        '/operations': 'Operations',
        '/clients': 'Clients',
        '/vessels': 'Vessels',
        '/users': 'User Management',
        '/settings': 'Settings',
        '/docs': 'Documentation',
        '/auth': 'Authentication',
        '/auth/reset-password': 'Reset Password',
      };

      return routes[pathname] || 'Unknown Page';
    };

    const pageTitle = getPageTitle(location.pathname);

    // Track page view
    analytics.pageView(location.pathname, pageTitle);

    // Track feature access
    analytics.track({
      name: 'feature_accessed',
      properties: {
        feature_name: pageTitle,
        page_path: location.pathname
      }
    });
  }, [location.pathname]);

  return null;
};
